/* eslint-disable object-property-newline */
/* eslint-disable no-lonely-if */
import gsap from 'gsap';
import * as messagesData from '../data/messages-data.json';
import Utils from '../utils';

const uiManagerComponent = {

  init() {
    window.uiManager = this;
    this.dialogueQueue = [];
    this.getComponents();
    this.subscribeToEvents();

    setTimeout(() => {
      window.uiManager.showHideLoading(false);
      setTimeout(() => {
        this.startScreenLogo.classList.remove('hideAlphaBottom');
        setTimeout(() => {
        this.startGameBtn.classList.remove('hideAlphaBottom');
        }, 500);
      }, 500);
    }, 300);

    this.onWindowResize();
  },

  getComponents() {
    this.loadingContainerElement = document.querySelector('#loading-container');
    this.blackOverlay = document.querySelector('#blackOverlay');
    this.rotateDeviceContainer = document.querySelector('#rotate-device-container');
    this.startScreenLogo = document.querySelector('#startScreenLogo');
    this.startGameBtn = document.querySelector('#startGameBtn');
    this.introMessageParent = document.querySelector('#introMessageParent');
    this.introMessageBtn = document.querySelector('#introMessageBtn');
    this.messageBoxParent = document.querySelector('#messageBoxParent');
    this.messageBoxTitle = document.querySelector('#messageBoxTitle');
    this.messageBoxText = document.querySelector('#messageBoxText');
    this.continueMessageBtn = document.querySelector('#continueMessageBtn');
    this.continueMessageBtn.onclick = this.continueMessageBtnPressed.bind(this);
    this.finalScreenParent = document.querySelector('#finalScreenParent');
    this.finalScreenBlackOverlay = document.querySelector('#finalScreenBlackOverlay');
    this.finalScreenShip = document.querySelector('#finalScreenShip');
    this.finalScreenLogo = document.querySelector('#finalScreenLogo');
    this.finalScreenText = document.querySelector('#finalScreenText');
    this.finalScreenBtn = document.querySelector('#finalScreenBtn');
  },

  subscribeToEvents() {
    window.addEventListener('resize', this.onWindowResize.bind(this));

    this.el.sceneEl.addEventListener('showMessage', (event) => {
      this.showMessage(event.detail.title, event.detail.message, event.detail.callback);
    });
  },

  onWindowResize() {
    if (Utils.isLandscape()) this.rotateDeviceContainer.classList.remove('fullyHidden');
    else this.rotateDeviceContainer.classList.add('fullyHidden');
  },

  showHideLoading(newValue = true) {
    if (this.loadingScreenVisible === newValue) return;
    this.loadingScreenVisible = newValue;

    if (newValue) this.loadingContainerElement.classList.remove('hideAlpha');
    else this.loadingContainerElement.classList.add('hideAlpha');
  },

  showHideBlackScreen(newValue) {
    if (newValue) this.blackOverlay.classList.remove('hideAlpha');
    else this.blackOverlay.classList.add('hideAlpha');
  },

  showIntroMessage(callback) {
    this.showHideIntroMessage(true);
    this.introMessageBtn.onclick = () => {
      this.showHideIntroMessage(false);
      if (callback && typeof callback === 'function') callback.call();
    };
  },

  showHideIntroMessage(newValue) {
    if (newValue) this.introMessageParent.classList.remove('hideAlpha');
    else this.introMessageParent.classList.add('hideAlpha');
  },

  showHideMessageBox(newValue) {
    if (newValue) this.messageBoxParent.classList.remove('hideAlphaBottom');
    else this.messageBoxParent.classList.add('hideAlphaBottom');
    this.el.sceneEl.components['game-manager'].setRaycastEnabled(!newValue);
  },

  showMessage(newTitle = '', newMessage = '', callback = null) {
    // console.log(`showMessage() - newMessage: "${newMessage}" - isArray: ${Array.isArray(newMessage)}`);
    this.dialogueQueue.length = 0; // Clear this.dialogueQueue array
    if (Array.isArray(newMessage)) {
      for (let i = 0; i < newMessage.length; i++) {
        this.dialogueQueue.push({ newTitle: newTitle, newMessage: newMessage[i] });
      }
    }
    else {
      this.dialogueQueue.push({ newTitle: newTitle, newMessage: newMessage });
    }
    if (callback && typeof callback === 'function') {
      this.callbackAfterMessage = callback;
    }
    this.checkDialogueQueue();
  },

  continueMessageBtnPressed() {
    window.audioManager.playSoundElement('#buttonSound');
    this.checkDialogueQueue();
  },

  showText(queueMessage) {
    this.messageBoxTitle.innerHTML = queueMessage.newTitle;
    this.messageBoxText.innerHTML = queueMessage.newMessage;
    this.showHideMessageBox(true);
  },

  checkDialogueQueue() {
    if (this.currentDialogueAudio) { // Stop previous dialogue audio
      window.audioManager.stopSoundElement(this.currentDialogueAudio);
    }
    if (this.dialogueQueue.length > 0) {
      const newText = this.dialogueQueue.shift();
      // console.log('checkDialogueQueue - newText:', newText);
      // console.log('checkDialogueQueue - messagesData[newText.newMessage]:', messagesData[newText.newMessage]);
      if (messagesData[newText.newMessage]) {
        this.currentDialogueAudio = messagesData[newText.newMessage].audioElement;
        window.audioManager.playSoundElement(this.currentDialogueAudio);
        newText.newMessage = messagesData[newText.newMessage].string;
      }
      this.showText(newText);
    }
    else {
      this.showHideMessageBox(false);
      if (this.callbackAfterMessage && typeof this.callbackAfterMessage === 'function') {
        this.callbackAfterMessage.call();
        this.callbackAfterMessage = null;
      }
    }
  },

  showCta() {
    const animationDuration = 7000;
    this.showHideFinalScreen(true);
    /*gsap.to(this.finalScreenShip, {
      scale: 0.2,
      duration: 3,
      ease: 'power2.out',
    });*/
    gsap.fromTo(this.finalScreenShip,
      {
        x: '-60vw',
        y: '-1vw',
        scale: 1,
      },
      {
        x: '34vw',
        y: '20vw',
        scale: 0,
        duration: animationDuration * 0.001,
        ease: 'power2.out',
      },
    );
    gsap.to(this.finalScreenShip, {
      opacity: 0,
      duration: animationDuration * 0.001,
      ease: 'power3.in',
    });
    setTimeout(() => {
      this.showHideCtaBlackOverlay(true);
      window.audioManager.playSoundElement('#ctaSound');
    }, animationDuration * 0.65);
  },

  showHideFinalScreen(newValue) {
    if (newValue) this.finalScreenParent.classList.remove('hideAlpha');
    else this.finalScreenParent.classList.add('hideAlpha');
  },

  showHideCtaBlackOverlay(newValue) {
    if (newValue) {
      this.finalScreenBlackOverlay.classList.remove('hideAlpha');
      this.finalScreenLogo.classList.remove('hideAlphaBottom');
      this.finalScreenText.classList.remove('hideAlphaBottom');
      this.finalScreenBtn.classList.remove('hideAlphaBottom');
    }
    else {
      this.finalScreenBlackOverlay.classList.add('hideAlpha');
      this.finalScreenLogo.classList.add('hideAlphaBottom');
      this.finalScreenText.classList.add('hideAlphaBottom');
      this.finalScreenBtn.classList.add('hideAlphaBottom');
    }
  },
};

export default uiManagerComponent;
